import React, { useEffect, useState } from "react";
import { Snackbar, SnackbarContent, IconButton, LinearProgress, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Toast = ({ open, message, onClose, severity = "success", autoHideDuration = 6000, errorMessage = "" }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (open) {
      setProgress(0);
      const timer = setInterval(() => {
        setProgress((prev) => {
          if (prev === 100) {
            clearInterval(timer);
            return prev;
          }
          return prev + (100 / (autoHideDuration / 100));
        });
      }, 100);

      return () => clearInterval(timer); 
    }
  }, [open, autoHideDuration]);

  const state = {
    vertical: 'top',
    horizontal: 'right',
  };

  const { vertical, horizontal } = state;

  const renderContent = () => {
    if (severity === "error") {
      return (
        <Alert severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      );
    } else {
      return (
        <SnackbarContent
          message={message}
          style={{
            backgroundColor: severity === "success" ? "green" : "red",
            paddingBottom: 0,
          }}
          action={
            <>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={onClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{
                  width: '100%',
                  height: 4,
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                }}
              />
            </>
          }
        />
      );
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical, horizontal }}
      sx={{
        zIndex: 1301,
      }}
    >
      {renderContent()}
    </Snackbar>
  );
};

export default Toast;
